"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = __importDefault(require("./base"));
const brand_1 = require("./brand");
const default_1 = __importDefault(require("../content/default"));
const base_2 = __importDefault(require("../content/base"));
const brand_2 = __importDefault(require("../content/brand"));
exports.default = (env) => {
    const confDefault = {
        tvg: default_1.default,
        pabets: default_1.default,
        iowa: default_1.default,
        "4njbets": default_1.default,
        fdr: default_1.default
    };
    const content = {
        production: { ...confDefault },
        staging: { ...confDefault },
        qa: { ...confDefault }
    };
    Object.keys(content).forEach((envName) => brand_1.BRAND_ALL.map((brand) => {
        // @ts-ignore
        const baseConf = base_2.default[envName];
        // @ts-ignore
        const brandConf = brand_2.default[envName][brand];
        // @ts-ignore
        content[envName][brand] = {
            // @ts-ignore
            ...content[envName][brand],
            ...baseConf,
            ...brandConf
        };
        return brand;
    }));
    const config = brand_1.BRAND_ALL.reduce((acc, brand) => ({
        ...acc,
        // @ts-ignore
        [brand]: base_1.default.config(content[env][brand])
    }), {});
    // @ts-ignore
    return config;
};



// WEBPACK FOOTER //
// ./node_modules/@tvg/conf/cjs/src/content.js